<template>
  <div class="container">
    <div class="weui-navbar daojia-navbar">
      <div class="daojia-navbar-left"><span class="icon-chevron-left" @click="goto('/cleanex/guide')"></span></div>

      <div class="daojia-navbar-left" v-show="$route.query.back" @click="$router.go(-1)"><span
          class="icon-chevron-left"></span></div>
      <h1 class="daojia-navbar-middle daojia-navbar-middle_logo"><a href="#"><img
            src="../../assets/img/global/logo.png"></a></h1>
      <div class="daojia-navbar-right">
      </div>
    </div>

    <div class="image-box">
      <template>
        <!-- <img :src='displayValue.titleImg' @click="$router.push('/service/clean-price?service=dasaochu');"> -->
        <div class="pjTitleBackg weui-flex " :class="displayValue.backgroundImage">
          <div class="weui-flex__item">
            <h2>{{ displayValue.title }}</h2>
            <div v-html="displayValue.titleText">
            </div>
            <div class="weui-flex__item btn-container"
              @click="$router.push(`/service/clean-price?service=${displayValue.backgroundImage}`);">
              <div class=" btn active">点击查看报价单 <span class="icon-chevron-right"></span></div>
            </div>
          </div>
        </div>

        <div class="multiLineImg">
          <div class="item">
            <div class="weui-flex">
              <div class="weui-flex__item img">
                <img :src="'/static/img/cleanEx/icon/' + displayValue.multiLineImg1[0]">
              </div>
              <div class="weui-flex__item img">
                <img :src="'/static/img/cleanEx/icon/' + displayValue.multiLineImg1[1]">
              </div>
              <div class="weui-flex__item img">
                <img :src="'/static/img/cleanEx/icon/' + displayValue.multiLineImg1[2]">
              </div>
              <div class="weui-flex__item img">
                <img :src="'/static/img/cleanEx/icon/' + displayValue.multiLineImg1[3]">
              </div>
            </div>
            <div class="weui-flex quality">
              <div class="weui-flex__item">
                <div>{{ displayValue.mlImgText[0] }}</div>
              </div>
              <div class="weui-flex__item">
                <div>{{ displayValue.mlImgText[1] }}</div>
              </div>
              <div class="weui-flex__item">
                <div>{{ displayValue.mlImgText[2] }}</div>
              </div>
              <div class="weui-flex__item">
                <div>{{ displayValue.mlImgText[3] }}</div>
              </div>
            </div>
          </div>
          <template v-if="['1550735948', '1550735960', '1550735971', '1550735962'].includes(order.data.type_id)">
            <div class="item">
              <div class="weui-flex">
                <div class="weui-flex__item img">
                  <img :src="'/static/img/cleanEx/icon/' + displayValue.multiLineImg2[0]">
                </div>
                <div class="weui-flex__item img">
                  <img :src="'/static/img/cleanEx/icon/' + displayValue.multiLineImg2[1]">
                </div>
                <div class="weui-flex__item img">
                  <img :src="'/static/img/cleanEx/icon/' + displayValue.multiLineImg2[2]">
                </div>
                <div class="weui-flex__item img">
                  <img :src="'/static/img/cleanEx/icon/' + displayValue.multiLineImg2[3]">
                </div>
              </div>
              <div class="weui-flex quality">
                <div class="weui-flex__item">
                  <div>{{ displayValue.mlImgText[4] }}</div>
                </div>
                <div class="weui-flex__item">
                  <div>{{ displayValue.mlImgText[5] }}</div>
                </div>
                <div class="weui-flex__item">
                  <div>{{ displayValue.mlImgText[6] }}</div>
                </div>
                <div class="weui-flex__item">
                  <div>{{ displayValue.mlImgText[7] }}</div>
                </div>
              </div>
            </div>
          </template>
        </div>

        <div class="filling ">
          <div class=" serve text-center">
            <div class="weui-flex serve_title ">
              <div class="weui-flex__item ">服务项目</div>
              <div class="weui-flex__item ">服务价格</div>
            </div>
            <div class="class= weui-flex serve">
              <div class="weui-flex__item" :class="displayValue.serveGreyBg">
                <template v-if="order.data.type_id == '1550735962'">
                  出车费
                </template>
                <template v-else>
                  主卧Master&nbsp;room
                </template>
              </div>
              <div class="weui-flex__item " :class="displayValue.serveGreyBg">${{ displayValue.serveFee[0] }}起</div>
            </div>
            <div class="class= weui-flex serve">
              <div class="weui-flex__item"><template v-if="order.data.type_id == '1550735962'">冰箱清洁
                </template>
                <template v-else>一室一厅
                </template>
              </div>
              <div class="weui-flex__item">${{ displayValue.serveFee[1] }}起</div>
            </div>
            <div class="weui-flex serve">
              <div class="weui-flex__item">
                <template v-if="order.data.type_id == '1550735962'">地毯清洁
                </template>
                <template v-else>两室一卫
                </template>
              </div>
              <div class="weui-flex__item">${{ displayValue.serveFee[2] }}起</div>
            </div>
          </div>
          <div class="weui-flex filling serve_button">
            <div class="weui-flex__item btn-container"
              @click="$router.push(`/service/clean-price?service=${displayValue.backgroundImage}`);">
              <div class=" btn active">查看完整报价单&nbsp; <span class="icon-chevron-right"></span></div>
            </div>
          </div>
        </div>
        <template v-if="['1550735948', '1550735960', '1550735971', '1550735961'].includes(order.data.type_id)">
          <img :src="(`/static/img/cleanEx/${displayValue.TimeComplexity}`)">
        </template>
        <template>
          <img :src="displayValue.cleanContentImg" v-if="displayValue.cleanContentImg">
        </template>
        <template v-if="['1550735962', '1550735960', '1550735971', '1550735961'].includes(order.data.type_id)">
          <img :src="displayValue.hexagonImg">
        </template>
        <template v-if="order.data.type_id == '1550735961'">
          <img src="/static/img/cleanEx/duanzu_07.jpg">
        </template>
        <template v-if="order.data.type_id == '1550735948'">
          <div class="text-center filling">
            <div class="weui-flex ">
              <div class="weui-flex__item title">使用场景</div>
            </div>
            <div class="weui-flex">
              <div class="weui-flex__item">
                <div class=""><img src="/static/img/cleanEx/dasaochu/dasaochu_07_1.jpg">
                </div>
              </div>
            </div>
            <div class="weui-flex content_filling">
              <div class="weui-flex__item">日常生活大扫除</div>
              <div class="weui-flex__item">家有宠物</div>
            </div>
            <div class="weui-flex">
              <div class="weui-flex__item">
                <div class=""><img src="/static/img/cleanEx/dasaochu/dasaochu_07_2.jpg">
                </div>
              </div>
            </div>
            <div class="weui-flex content_filling">
              <div class="weui-flex__item">Party大扫除</div>
              <div class="weui-flex__item">年节大扫除</div>
            </div>
          </div>
          <img src='/static/img/cleanEx/dasaochu_08.jpg'>
          <img src='/static/img/cleanEx/dasaochu_09.jpg'>
        </template>
        <template v-if="['1550735960', '1550735971'].includes(order.data.type_id)">
          <div class="text-center fillin service_content">
            <div class="weui-flex ">
              <div class="weui-flex__item title">服务内容</div>
            </div>
            <div class="weui-flex">
              <div class="weui-flex__item">
                <img src="/static/img/cleanEx/dasaochu/fuwu1.jpg">
              </div>
            </div>
            <div class="weui-flex">
              <div class="weui-flex__item content_filling">废弃物垃圾处理</div>
              <div class="weui-flex__item content_filling">家具表面除尘</div>
            </div>
            <div class="weui-flex">
              <div class="weui-flex__item">
                <img src="/static/img/cleanEx/dasaochu/fuwu2.jpg">

              </div>
            </div>
            <div class="weui-flex">
              <div class="weui-flex__item content_filling">家电内外除污</div>
              <div class="weui-flex__item content_filling">厨卫污垢清理</div>
            </div>
            <div class="weui-flex">
              <div class="weui-flex__item">
                <template v-if="order.data.type_id == '1550735960'">
                  <img src="/static/img/cleanEx/dasaochu/fuwu3.jpg">
                </template>
                <template v-if="order.data.type_id == '1550735971'">
                  <img src="/static/img/cleanEx/dasaochu/zhouqi_07.jpg">
                </template>
              </div>
            </div>
            <div class="weui-flex">
              <div class="weui-flex__item content_filling">卫浴水垢清理</div>
              <div class="weui-flex__item content_filling"><template
                  v-if="order.data.type_id == '1550735960'">高压蒸汽地毯蒸洗</template><template
                  v-if="order.data.type_id == '1550735971'">大功率吸尘器吸尘</template></div>
            </div>
          </div>
        </template>
        <template v-if="order.data.type_id == '1550735962'">
          <div class="text-center filling">
            <div class="title">
              专业清洗工具
            </div>
            <div class="weui-flex">
              <div class="weui-flex__item">
                <div><img src="/static/img/cleanEx/dasaochu/zhuanxiang_07.jpg"></div>
              </div>
            </div>
            <div class="weui-flex">
              <div class="weui-flex__item content_filling image_caption">大功率吸尘器</div>
              <div class="weui-flex__item content_filling image_caption">高压蒸汽除霉除菌洗毯机</div>
            </div>
            <div class="weui-flex">
              <div class="weui-flex__item">
                <div><img src="/static/img/cleanEx/dasaochu/zhuanxiang_07_2.jpg"></div>
              </div>
            </div>
            <div class="weui-flex">
              <div class="weui-flex__item content_filling image_caption">专利DC&nbsp;Cleanser成分清洗液</div>
              <div class="weui-flex__item content_filling image_caption">厨房专用除油粉除油剂</div>
            </div>
          </div>
        </template>
        <template v-if="order.data.type_id == '1550735962'">
          <div class="title text-center">服务内容</div>
          <div class="filling serve text-center">
            <div class="weui-flex serve_title_orange ">
              <div class="weui-flex__item flex-short clean_title">清洗类型</div>
              <div class="weui-flex__item flex-long clean_title flex-long_content">清洗内容</div>
            </div>
            <div class="class= weui-flex ">
              <div class="weui-flex__item flex-short">油烟机</div>
              <div class="weui-flex__item flex-long flex-long_content">油烟机外面板、油烟机内面板、油网、储油斗、风扇</div>
            </div>
            <div class="class= weui-flex ">
              <div class="weui-flex__item flex-short">烤箱</div>
              <div class="weui-flex__item flex-long flex-long_content">烤箱外面板、内部四壁、层架、托盘、烤盘、外延夹缝</div>
            </div>
            <div class="weui-flex ">
              <div class="weui-flex__item flex-short">灶台</div>
              <div class="weui-flex__item flex-long flex-long_content">炉具、炉架、打火开关、</div>
            </div>
            <div class="weui-flex ">
              <div class="weui-flex__item flex-short">冰箱</div>
              <div class="weui-flex__item flex-long flex-long_content">冰箱顶部四周、通风栅、冰箱内壁、隔板、储物栏</div>
            </div>
            <div class="weui-flex">
              <div class="weui-flex__item flex-short">玻璃窗</div>
              <div class="weui-flex__item flex-long flex-long_content">内外玻璃、窗户框、窗户槽、窗户锁</div>
            </div>
          </div>
          <div class="weui-flex serve_button text-center">
            <div class="weui-flex__item btn-container"
              @click="$router.push('/service/clean-price?service=zhuanxiang');">查看更多</div>
          </div>
        </template>
        <template v-if="['1550735948', '1550735960', '1550735971', '1550735961'].includes(order.data.type_id)">
          <div class="notice">
            <h4>温馨提示：</h4>
            <p>家电、厨电的内部清洁不在服务范围，此类需求请参考<a @click="$router.push('/service/clean-price?service=zhuanxiang')">专项清洁服务;</a>
            </p>
            <p>窗外玻璃以及纱窗、百叶窗、防护窗清洗不在清洗范围内，此类需求请参考<a
                @click="$router.push('/service/clean-price?service=zhuanxiang')">玻璃清洁服务</a>；</p>
            <p>窗帘、古董字画、宗教陈设、花草绿植、天花板及其附属品（灯具、吊顶等）不在清洁范围内。</p>
          </div>
        </template>
        <template v-if="['1550735948', '1550735960', '1550735971'].includes(order.data.type_id)">
          <div>
            <div class="text-center filling">
              <div class="weui-flex toolKit_title">
                <div class="weui-flex__item color-orange title_left">绿色环保</div>
                <div class="weui-flex__item title_right">专业工具套装</div>
              </div>
              <div class="weui-flex">
                <div class="weui-flex__item">
                  <div><img src="/static/img/cleanEx/dasaochu/dasaochu_10.jpg"></div>
                </div>
              </div>
              <div class="weui-flex">
                <div class="weui-flex__item content_filling image_caption">九色分区毛巾</div>
                <div class="weui-flex__item content_filling image_caption">四色百洁布</div>
              </div>
              <div class="weui-flex">
                <div class="weui-flex__item">
                  <div><img src="/static/img/cleanEx/dasaochu/dasaochu_10_2.jpg"></div>
                </div>
              </div>
              <div class="weui-flex">
                <div class="weui-flex__item content_filling image_caption">专利DC&nbsp;Cleanser成分清洗液</div>
                <div class="weui-flex__item content_filling image_caption">高压蒸汽除霉菌除菌地毯机</div>
              </div>
            </div>



            <div class="text-center filling">
              <div>
                <div class="weui-flex__item check-square"><span class="icon-check-square">&nbsp;</span>清洁工具清污分离，避免混用隔绝污染
                </div>
              </div>
              <div>
                <div class="weui-flex__item check-square"><span
                    class="icon-check-square ">&nbsp;</span>清洁抹布干湿分离，分区使用确保卫生
                </div>
              </div>
              <div class="weui-flex__item check-square"><span class="icon-check-square ">&nbsp;</span>清洁剂温和无刺激，安全环保健康放心
              </div>
              <div>
              </div>
            </div>
          </div>
        </template>
        <template v-if="order.data.type_id == '1550735948'">
          <img src="/static/img/cleanEx/dasaochu_11.jpg">
        </template>
        <template v-if="order.data.type_id == '1550735960'">
          <img src="/static/img/cleanEx/tuifang_10.jpg">
        </template>
        <template v-if="order.data.type_id == '1550735962'">
          <img src="/static/img/cleanEx/zhuanxiang_09.jpg">
        </template>
        <template v-if="order.data.type_id == '1550735961'">
          <img src="/static/img/cleanEx/duanzu_08.jpg">
        </template>
        <img src='/static/img/cleanEx/dasaochu/dasaochu_12.jpg'>
        <div class="service-guarantee">
          <h2>专业服务&nbsp;双重保障</h2>
          <p>1、定制保险，全程护航</p>
          <p>发生财产损坏时及时协商佩服保障您的财产安全。</p>
          <br>
          <p>2、专业客服，保障权益</p>
          <p>专业团队快速响应，如遇问题，请拨打客服热线：047&nbsp;774&nbsp;777</p>
        </div>
        <div class="space"></div>
      </template>
    </div>
    <div class="btn-box-fix">
      <!--       <div class="slogan">点击查看
        <span class="color-orange">
          <span v-if="order.data.type_id=='1550735948'" @click="$router.push('/service/clean-price?service=dasaochu');">大扫除清洁报价单</span>
          <span v-if="order.data.type_id=='1550735960'" @click="$router.push('/clean-pricing')">退房 / 开荒清洁报价单</span>
          <span v-if="order.data.type_id=='1550735961'" @click="$router.push('/service/clean-price?service=duanzuwu');">短租屋清洁报价单</span>
          <span v-if="order.data.type_id=='1550735962'" @click="$router.push('/service/clean-price?service=zhuanxiang');">专项清洁报价单</span>
          <span v-if="order.data.type_id=='1550735971'" @click="$router.push('/service/clean-price?service=zhouqi');">周期清洁报价单</span>
        </span>
      </div> -->

      <div class="slogan">
        <span class="promo-stats" v-show="Object.keys(orderStats).length > 0">近30天有<span class="color-orange">{{
          orderStats['clean_num']
        }}</span>人选择到家清洁，好评率<span class="color-orange">{{
  orderStats['clean_trade']
            }}%</span></span>
      </div>
      <div class="btn-container">
        <a href="javascript:void(0)" v-if="order.data.type_id == '1550735960'" class="btn active"
          @click="goto('/clean-step1?msg=' + order.data.msgAttach)">开始下单</a>
        <a href="javascript:void(0)" v-else class="btn active" @click="goto('/cleanEx-step1')">开始下单</a>
      </div>
    </div>

    <img :src="pixelURL('qingjie', 'baojia')" class="hide">
  </div>
</template>

<script>
import Template from '../baggage/template.vue';

export default {
  name: 'work',
  data() {
    return {
      order: {},
      orderStats: {},
    }
  },
  computed: {
    workingHours: function () {
      let d = new Date();
      let time = d.getHours();
      return time;
    },
    displayValue: function () {
      let result = '';
      switch (this.order.data.type_id) {
        case '1550735948':
          result = {
            backgroundImage: 'dasaochu',
            title: '大扫除清洁',
            titleText: '<p>适合需要深度打扫的用户</p><p>专业清理使你的房屋焕然一新！</p>',
            titleImg: '/static/img/cleanEx/dasaochu_02.jpg',
            TimeComplexity: 'dasaochu_05.png',
            cleanContentImg: '/static/img/cleanEx/dasaochu_06.jpg',
            multiLineImg1: ['DustRemoval.png', 'Sorting.png', 'cupboard.png', 'OilStain.png'],
            multiLineImg2: ['brush.png', 'heat.png', 'Pro.png', 'excuse.png'],
            mlImgText: ['360除尘', '整理房间', '清理橱柜', '清理油污', '不留死角', '高温消毒', '专业工具', '全面保障'],
            serveFee: ["120", '150', '170'],
          };
          break;
        case '1550735960':
          result = {
            backgroundImage: 'tuifang',
            title: '退房清洁 / 开荒清洁',
            titleText: '<p>适合即将退房的租户,保证房东满意退押金!</p><p>适合装修完需要清洁打扫的用户，打造无尘新空间！</p>',
            titleImg: "/static/img/cleanEx/tuifang_02.jpg",
            TimeComplexity: 'tuifang_05.png',
            cleanContentImg: '/static/img/cleanEx/tuifang_06.jpg',
            multiLineImg1: ['DustRemoval.png', 'Sorting.png', 'cupboard.png', 'OilStain.png'],
            multiLineImg2: ['brush.png', 'heat.png', 'Pro.png', 'excuse.png'],
            mlImgText: ['除尘清洁', '整理房间', '清理橱柜', '清理油污', '清理水垢', '价格透明', '专业工具', '全面保障'],
            serveFee: ["159", '230', '270'],
            hexagonImg: "/static/img/cleanEx/tuifang_07.jpg",
          };
          break;
        case '1550735962':
          result = {
            backgroundImage: 'zhuanxiang',
            title: '专项清洁',
            titleText: '<p>适合需要针对性清洁的用户</p><p>地毯，油烟机，门窗等保洁不在困难</p><p>宠物爱窝，卫生死角，不在费心</p>',
            titleImg: "/static/img/cleanEx/zhuanxiang_02.jpg",
            cleanContentImg: '/static/img/cleanEx/zhuanxiang_05.jpg',
            multiLineImg1: ['leaf.png', 'scaleDeposit.png', 'brush.png', 'heat.png'],
            multiLineImg2: ['wrench.png', 'clean.png', 'Pro.png', 'excuse.png'],
            mlImgText: ['安全环保', '清污除垢', '清理死角', '高温消毒', '深度拆洗', '干净无尘', '专业工具', '全面保障'],
            serveGreyBg: "serve_title",
            serveFee: ["60", '20', '70'],
            hexagonImg: "/static/img/cleanEx/zhuanxiang_06.jpg",
          };
          break;
        case '1550735971':
          result = {
            backgroundImage: 'zhouqi',
            title: '周期性清洁',
            titleText: '<p>适合需要定期家庭保洁的用户</p><p>让生活更干净！让家人更健康！</p>',
            titleImg: "/static/img/cleanEx/zhouqi_02.jpg",
            TimeComplexity: 'zhouqi_05.jpg',
            cleanContentImg: false,
            multiLineImg1: ['Sorting.png', 'cupboard.png', 'scaleDeposit.png', 'DustRemoval.png'],
            multiLineImg2: ['brush.png', 'price.png', 'Pro.png', 'excuse.png'],
            mlImgText: ['整理房间', '清理橱柜', '清理水垢', '全面除尘', '不留死角', '价格透明', '专业工具', '全面保障'],
            serveFee: ["100", '100', '100'],
            hexagonImg: "/static/img/cleanEx/zhouqi_06.jpg",
          };
          break;
        case '1550735961':
          result = {
            backgroundImage: 'duanzuwu',
            title: '短租房清洁',
            titleText: '<p>适合短期租房的出租者</p><p>高效清洁，不耽误旺季客户入住</p>',
            titleImg: "/static/img/cleanEx//duanzu_02.jpg",
            TimeComplexity: 'duanzu_04.png',
            cleanContentImg: '/static/img/cleanEx/duanzu_05.jpg',
            multiLineImg1: ['DustRemoval.png', 'Sorting.png', 'cupboard.png', 'OilStain.png'],
            mlImgText: ['全面除尘', '整理房间', '清理橱柜', '清理油污'],
            serveFee: ["40", '50', '70'],
            hexagonImg: "/static/img/cleanEx/duanzu_06.jpg",
          };
          break;
        default:
          console.log("Sorry, we are out of service.");
      }
      return result;
    },
  },
  components: {
    Template
  },
  created: function () {
    if (localStorage.order) {
      let localParsed = JSON.parse(localStorage.order);
      this.order = localParsed;
    }
    else {
      this.$router.push('/');
    }
    if (localStorage.orderStats) {
      this.orderStats = JSON.parse(localStorage.orderStats);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

html {
  background-color: #f7f7f7;
}



.container {
  padding-top: 50px;
  height: 100vw;
}

.pjTitleBackg {
  background-size: cover;
  background-position: center;
  padding: 10vh 30px 10vh 30px;
  color: #f7f7f7;
  text-align: center;
  font-size: 3.5vw;

  h2 {
    font-size: 7vw;
    line-height: 40px;
  }

  .btn-container {
    padding-top: 20px;
  }
}

.dasaochu {
  background-image: url("../../../static/img/cleanEx/dasaochu/dasaochuTitle.jpg");
}

.tuifang {
  background-image: url("../../../static/img/cleanEx/dasaochu/tuifangTitle.jpg");
}

.zhuanxiang {
  background-image: url("../../../static/img/cleanEx/dasaochu/zhuanxiangTitle.jpg");
}

.duanzuwu {
  background-image: url("../../../static/img/cleanEx/dasaochu/duanzuTitle.jpg");
}

.zhouqi {
  background-image: url("../../../static/img/cleanEx/dasaochu/zhouqiTitle.jpg");
}

.notice {
  padding: 10px 7.2vw 10px 7.2vw;
  margin: 0 0 10px 0;
  -webkit-box-align: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  color: #989898;

  h4 {
    font: size 4.5vw;
    color: #787880;
    font-weight: 400;
  }

  p {
    font-size: 3.5vw;
    text-indent: 6vw;
  }

  a {
    color: #0089F4;
  }

}

.toolKit_title {
  font-size: 7vw;
  color: #5e5e6e;
  margin: 10px 0 10px 0;
  font-weight: bolder;

  .title_left {
    flex: 3;
    text-align: right;
    padding: 0 10px 0 0;
  }

  .title_right {
    flex: 4;
    text-align: left;
  }
}

.image-box {
  img {
    width: 100%;
  }
}

.btn {
  margin-top: 0px;
  height: 9vw;
  width: 40vw;
  font-size: 4vw;
  font-weight: 400;
}

.slogan {
  margin-top: 6px;
  margin-bottom: 5px;
  font-size: 0.8em;
  text-align: center;
}

.btn-box-fix .btn.active {
  margin-left: 0;
  margin-top: 0;
}

.daojia-navbar {
  position: fixed;
  background: rgba(255, 255, 255, 0.95);
  padding: 8px 10px;
  box-sizing: border-box;
  height: 50px;
}

.daojia-navbar-left {
  display: block;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  text-align: left;

  span {
    font-size: 2em;
    color: #666;
  }
}

.daojia-navbar-middle_logo img {
  height: 34px;
}

.daojia-navbar-middle {
  display: block;
  -webkit-box-flex: 2;
  -webkit-flex: 2;
  flex: 2;
  motion-rotation: antialiased;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  font-family: sans-serif;
  font-size: 1.2em;
  line-height: 1.3;
  font-weight: bold;
}

.daojia-navbar-right {
  font-size: 14px;
  line-height: 26px;
  display: block;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  text-align: right;
}


.filling {
  padding: 10px 20px 10px 20px;
  margin: 0 0 10px 0;
  -webkit-box-align: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;

  img {
    width: 100%;
  }
}

.content_filling {
  padding: 10px 0 10px 0;

}


.item {
  padding: 20px 0 0 0;
}

.multiLineImg {
  padding: 0 0px 40px 0px;



  .img {
    display: flex;
    justify-content: center;
    /*水平居中*/
    align-items: center;
    padding-bottom: 10px;
  }

  img {
    width: 10.5vw;
    height: 10.5vw;
  }
}

.quality {
  width: 100%;
  text-align: center;
  font-size: 3.4vw;
  color: #5A5E68;
}

.image_caption {
  width: 25px;
  font-size: 4.3vw;
}

.check-square {
  line-height: 8vw;
  color: #919191;
  font-size: 3.5vw;

  .icon-check-square {
    color: #f87551;
  }
}

.serve {
  line-height: 10vw;
  font-size: 4vw;
  color: #5A5E68;
  border: none;


  .serve_title_orange {
    background: #f87148;

  }

  .serve_title {
    background-color: #F8F9FB;

  }

  div {
    border-style: solid;
    border-color: #d0d0d05b;
    border-width: 0.1px;
    margin-bottom: -0.2px;
  }

  .clean_title {
    color: #ffffff;
  }

}

.flex-short {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 2;
}

.flex-long {
  flex: 4;

  &.flex-long_content {
    line-height: 25px;
    padding: 10px 20px 10px 20px;
  }
}

.serve_button {
  align-items: center;
}

.btn-box-fix .btn.active {
  margin-left: 0;
}

.promo-stats {
  border-radius: 50px;
  background: #f7f7f7;
  padding: 4px 12px;
  margin: 4px 0;
  display: inline-block;
}

.service-guarantee {
  background-image: url(../../../static/img/cleanEx/dasaochu/dasaochu_13.jpg);
  background-size: cover;
  background-position: center;
  padding: 6vw 6vw 10vw 6vw;
  font-size: 1em;
  color: #f7f7f7;
  line-height: 5vw;

  h2 {
    text-align: center;
    font-size: 1.4em;
    line-height: 1.2em;
    padding: 3vw 0 4vw 0;
  }


}

.service-guarantee p:nth-child(3),
.service-guarantee p:nth-child(5) {
  padding-bottom: 5px;
  font-size: 1em;
}

.space {
  padding-top: 13.3vh;
}
</style>



// WEBPACK FOOTER //
// src/pages/cleanEx/step0.vue